import { render, staticRenderFns } from "./AddAliasForm.vue?vue&type=template&id=cafcafd0&"
import script from "./AddAliasForm.vue?vue&type=script&lang=js&"
export * from "./AddAliasForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cafcafd0')) {
      api.createRecord('cafcafd0', component.options)
    } else {
      api.reload('cafcafd0', component.options)
    }
    module.hot.accept("./AddAliasForm.vue?vue&type=template&id=cafcafd0&", function () {
      api.rerender('cafcafd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Domains/Aliases/AddAliasForm.vue"
export default component.exports